<template>
  <div>
    <div class="d-flex flex-column">
      <div class="d-inline-flex mr-2">
        <div class="d-flex flex-column">
          <label class="font-weight-bold">Start:</label>
          <div class="d-flex log-datetime" aria-label="Start">
            <input class="form-control log-datetime__date" type="date" min="2011-01-01" v-model="filterParams.startProcessedDate">
            <input class="form-control log-datetime__time" type="time" v-model="filterParams.startProcessedTime">
          </div>
        </div>
        <div class="d-flex flex-column ml-2">
          <label class="font-weight-bold">End:</label>
          <div class="d-flex log-datetime" aria-label="End">
            <input class="form-control log-datetime__date" type="date" min="2011-01-01" v-model="filterParams.endProcessedDate">
            <input class="form-control log-datetime__time" type="time" v-model="filterParams.endProcessedTime">
          </div>
        </div>
      </div>
      <div class="btn-group btn-logging-filter-group mt-2">
        <button :class="{ active: filterParams.statusType === 'FAIL' }" @click="handleStatusType('FAIL')" class="btn btn-outline-primary">Errors</button>
        <button :class="{ active: filterParams.statusType === 'SUCCESS' }" @click="handleStatusType('SUCCESS')" class="btn btn-outline-primary">Success</button>
        <button :class="{ active: filterParams.statusType === 'IGNORE' }" @click="handleStatusType('IGNORE')" class="btn btn-outline-primary">Ignore</button>
        <button :class="{ active: filterParams.statusType === 'WARNING' }" @click="handleStatusType('WARNING')" class="btn btn-outline-primary">Warning</button>
        <button :class="{ active: filterParams.statusType === '' }" @click="handleStatusType('')" class="btn btn-outline-primary">All</button>
        <button @click="toggleAdvancedParams" class="btn btn-primary">Advanced</button>
        <button class="btn btn-success" @click="doFilter" :disabled="allFieldsInvalid">Submit</button>
      </div>
    </div>
    <transition>
      <div v-if="showAdvancedParams" class="communication-logs__drawer">
        <div class="communication-logs__drawer-bg" @click="toggleAdvancedParams()"></div>
        <div class="communication-logs__drawer-wrapper">
          <div class="d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">Advanced Parameters</span>
            <button @click="toggleAdvancedParams()" class="btn btn-warning btn-sm">Close</button>
          </div>
          <div class="communication-logs__drawer-inner d-flex flex-column">
            <div class="d-flex flex-column advanced-params">
              <div class="d-flex flex-column mt-4">
                <div class="d-flex">
                  <div class="d-flex flex-column">
                    <label class="font-weight-bold" for="http-code">HTTP Code:</label>
                    <input class="form-control http-code" type="text" id="http-code" name="http-code" min="100" max="999" v-model="filterParams.httpCode" @change="doFilter">
                  </div>
                </div>
              </div>
              <div class="d-flex mt-4">
                <div class="d-flex flex-column">
                  <label class="font-weight-bold">Channels:</label>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="Channels">
                      {{ filterParams.channelId.length === 0 ? 'All' : filterParams.channelName }}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="top: auto;" v-if="channels.length">
                      <a class="dropdown-item" href="#" @click="clearSelectedChannel">All</a>
                      <a class="dropdown-item" href="#" v-for="channel in channels" :key="channel.channel_name" @click="handleSelectChannel(channel)">{{ channel.channel_name }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex flex-column mt-4">
                  <label class="font-weight-bold" for="action">Action:</label>
                  <input class="form-control" type="text" id="action" placeholder="Action" v-model="filterParams.action" @keyup.enter="doFilter">
                </div>
                <div class="d-flex flex-column mt-4">
                  <label class="font-weight-bold" for="pcs_id">PIM ID:</label>
                  <input class="form-control" type="text" id="pcs_id" placeholder="PIM ID" v-model="filterParams.pcsId" @keyup.enter="doFilter">
                </div>
                <div class="d-flex flex-column mt-4">
                  <label class="font-weight-bold" for="bc_id">Web ID:</label>
                  <input class="form-control" type="text" id="bc_id" placeholder="Web ID" v-model="filterParams.bcId" @keyup.enter="doFilter">
                </div>
                <div class="d-flex flex-column mt-4">
                  <label class="font-weight-bold" for="entity_type">Entity Type:</label>
                  <input class="form-control" type="text" id="entity_type" placeholder="Entity Type" v-model="filterParams.entityType" @keyup.enter="doFilter">
                </div>
                <div class="d-flex flex-column mt-4">
                  <label class="font-weight-bold" for="message">Message:</label>
                  <input class="form-control" type="text" id="message" placeholder="Message" v-model="filterParams.message" @keyup.enter="doFilter">
                </div>
              </div>
              <div class="d-flex mt-4">
                <button class="btn" :class="[allFieldsInvalid ? 'btn-outline-secondary' : 'btn-outline-danger']" :disabled="allFieldsInvalid" @click="resetFilter">Clear</button>
                <button class="btn btn-success ml-2" @click="handleDrawerSubmit" :disabled="allFieldsInvalid">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style scoped lang="scss">
.btn-group {
    .btn-outline-primary {
        color: #333333;
        border: solid 1px #dee0e1;
        &.active {
            z-index: 10;
        }
    }
}

.http-code {
    width: 8em;
}

.log-datetime {
    border: 1px solid #dedede;
    border-radius: 5px;
}

.log-datetime__date {
    width: 10rem;
    border: none;
    border-right: solid 1px #dedede;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.log-datetime__time {
    border: none;
    width: 8rem;
}

.btn-fade-enter-active,
.btn-fade-leave-active {
    transition: opacity 0.5s;
}

.btn-fade-enter,
.btn-fade-leave-to {
    transition: opacity 0.5s;
    opacity: 0;
}

.communication-logs__drawer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1020;

    .communication-logs__drawer-bg {
        background-color: rgba(30, 30, 30, 0.6);
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1021;
        cursor: pointer;
    }

    .communication-logs__drawer-wrapper {
        width: 100%;
        height: 100%;
        max-width: 28rem;
        min-width: 22rem;
        position: absolute;
        top: 0;
        right: 0;
        background: white;
        z-index: 1022;
        padding: 1rem;
        overflow-y: scroll;
    }
}
</style>
<script>
import axios from "axios";
import moment from 'moment';

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    props: ["placeholder"],
    data() {
        return {
            filterParams: {
                action: "",
                channelId: "",
                channelName: "",
                startProcessedTime: "",
                startProcessedDate: "",
                endProcessedTime: "",
                endProcessedDate: "",
                bcId: "",
                pcsId: "",
                message: "",
                statusType: "",
                entityType: "",
                httpCode: ""
            },
            showAdvancedParams: false,
            channels: []
        };
    },
    computed: {
        allFieldsInvalid() {
            let filterValues = Object.values(this.filterParams);

            return filterValues.every(field => {
                return field.length === 0 || field == null;
            });
        },
        startProcessedDatetime() {
            const isValidTime = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(
                this.filterParams.startProcessedTime
            );

            let datetime = isValidTime
                ? `${this.filterParams.startProcessedDate} ${this.filterParams.startProcessedTime}`
                : `${this.filterParams.startProcessedDate} 00:00`;

            datetime = moment.utc(datetime);

            return datetime.toString().split(" (")[0];
        },
        endProcessedDatetime() {
            const isValidTime = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(
                this.filterParams.endProcessedTime
            );

            let datetime = isValidTime
                ? `${this.filterParams.endProcessedDate} ${this.filterParams.endProcessedTime}`
                : `${this.filterParams.endProcessedDate} 00:00`;

            datetime = moment.utc(datetime);

            return datetime.toString().split(" (")[0];
        }
    },
    watch: {
        "filterParams.httpCode": {
            handler: function(newValue, oldValue) {
                let validStatus = newValue.replace(/[^0-9.]/g, "");

                this.filterParams.httpCode =
                    validStatus.length <= 3
                        ? validStatus
                        : validStatus.substring(0, 3);
            },
            immediate: true
        }
    },
    created() {
        const escapeHandler = e => {
            if (e.key === "Escape" && this.showAdvancedParams) {
                this.showAdvancedParams = false;
                this.resetFilter();
            }
        };

        document.addEventListener("keydown", escapeHandler);

        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", escapeHandler);
        });
    },
    mounted() {
        const endpoint = base_url + "/channels/grid?per_page=100";

        axios
            .get(endpoint)
            .then(response => {
                this.channels = response.data.data;
            })
            .catch(error => {
                console.log("error:", error);
            });

        this.setDefaultDateRange();

        this.$nextTick(() => {
            this.doFilter();
        });
    },
    methods: {
        setDefaultDateRange() {
            let currentEnd = moment.utc();
            let currentStart = moment.utc().subtract(7, 'days');

            this.filterParams.startProcessedTime = `00:00`;
            this.filterParams.endProcessedTime = `${(currentEnd.hours() < 10 ? "0" : "")
                + currentEnd.hours()}:${(currentEnd.minutes() < 10 ? "0" : "") + currentEnd.minutes()}`;

            this.filterParams.startProcessedDate = currentStart
                .toISOString()
                .split("T")[0];
            this.filterParams.endProcessedDate = currentEnd
                .toISOString()
                .split("T")[0];
        },
        handleStatusType(type) {
            this.filterParams.statusType = type;
        },
        handleSelectChannel(channel) {
            this.filterParams.channelId = channel.id;
            this.filterParams.channelName = channel.channel_name;
        },
        clearSelectedChannel() {
            this.filterParams.channelId = "";
            this.filterParams.channelName = "";

            this.$nextTick(() => {
                this.doFilter();
            });
        },
        toggleAdvancedParams() {
            this.showAdvancedParams = !this.showAdvancedParams;
        },
        doFilter() {
            this.$events.fire("filter-set", {
                action: this.filterParams.action,
                channelId: this.filterParams.channelId,
                bcId: this.filterParams.bcId,
                startProcessedTime: this.startProcessedDatetime,
                endProcessedTime: this.endProcessedDatetime,
                pcsId: this.filterParams.pcsId,
                message: this.filterParams.message,
                statusType: this.filterParams.statusType,
                entityType: this.filterParams.entityType,
                httpCode: this.filterParams.httpCode
            });
        },
        handleDrawerSubmit() {
            this.doFilter();
            this.$nextTick(function() {
                this.showAdvancedParams = false;
            });
        },
        resetFilter() {
            this.filterParams = {
                action: "",
                channelId: "",
                channelName: "",
                entityType: "",
                bcId: "",
                pcsId: "",
                message: "",
                statusType: "",
                httpCode: ""
            };

            this.setDefaultDateRange();

            this.$nextTick(() => {
                this.doFilter();
            });
        }
    }
};
</script>
